module.exports = __webpack_public_path__ + "d94e20c1/img/arrow-share-icon.00a12c29.svg";